<con-app profileLink="./me" accountLabel="Connect Administration" [links]="links">

    <router-outlet></router-outlet>

</con-app>